import gql from 'graphql-tag';

export const ShopFragment = gql`
  fragment ShopStageFragment on ShopModel {
    id
    opens_soon
    icon_list
    icon_map
    title
    type
    address
    ya_maps_url
    phone
    schedule {
      days
      hours
    }
    geo
    images {
      file_webp
      file
    }
    paymentTypes {
      title
    }
    nearestDelivery {
      date
      title
      time
      interval
      price
    }
    metroStations {
      id
      title
      line {
        id
        title
        color
      }
    }
  }
`;

const ShopsStageQuery = {
  getShopsByCartToken: gql`
    query getShopsByCartToken($cartToken: String!) {
      getShops(cartToken: $cartToken) {
        ...ShopStageFragment
      }
    }
    ${ShopFragment}
  `
};

export default ShopsStageQuery;
